import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class RespostaApi {

  cancelTokens = {
    getRespostas: null,
    getResposta: null,
    setResposta: null,
    destroyResposta: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getRespostas({ page = 1, qtd_por_pagina, texto, ativo }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      texto,
      ativo,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getRespostas = source;
  
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/respostas?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getRespostas = null;
    return data;
  }

  async getResposta(respostaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getResposta = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/respostas/${respostaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getResposta = null;
    return data;
  }

  async destroyResposta(respostaId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyResposta = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/respostas/${respostaId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyResposta = null;
    return data;
  }


  async setResposta(resposta) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.setResposta = source;

    const dadosResposta = {
      resposta: {
        texto: resposta.texto,
        ativo: resposta.ativo,
      },
    };

    if (resposta.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/respostas/${resposta.id}`,
        dadosResposta,
        {
          cancelToken: source.token,
        }
      );
      this.cancelTokens.setResposta = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/respostas`,
        dadosResposta,
        {
          cancelToken: source.token,
        }
      );
      this.cancelTokens.setResposta = null;
      return data;
    }
  }
}

export default RespostaApi;